<template>
  <div class="overview">
    <nav-menu :id="id" :active-index="2"></nav-menu>
    <div class="overview-top">
      <div style="width: 45%;">
        <common-panel>
          <div class="base-info">
            <div class="base-left">
              <div class="info-title">
                <span>{{(infoAndContract.projectInfoVo || {}).projectName}}</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="hight">施工中</span>
              </div>
              <div class="normal-text">
                <span>
                  {{`${this.$moment((infoAndContract.projectInfoVo || {})
                    .planStartupTime).format('YYYY年M月D日')}
                   — ${this.$moment((infoAndContract.projectInfoVo || {})
                    .planCompletedTime).format('YYYY年M月D日')}`}}
                </span>
              </div>
              <div class="normal-text">
                <span>剩余工期： </span>
                <span class="title hight">
                  {{(infoAndContract.projectInfoVo || {}).remainTime > 0
                    ? `${(infoAndContract.projectInfoVo || {}).remainTime}天`
                    : `延期${-(infoAndContract.projectInfoVo || {}).remainTime}天`
                  }}
                </span>
                &nbsp;&nbsp;&nbsp;
                <span>
                  工程规模：
                  {{(infoAndContract.projectInfoVo || {}).projectSize}}
                  {{(infoAndContract.projectInfoVo || {}).sizeUnitDesc}}
                </span>
              </div>
              <div class="normal-text">
                <span>
                  施工队伍：
                  {{(infoAndContract.projectInfoVo || {}).receptCompany}}
                </span>
              </div>
              <div class="normal-text">
                <span>
                  项目经理：
                  {{(infoAndContract.projectInfoVo || {}).pm}}
                </span>
              </div>
            </div>
            <div class="base-right">
              <v-chart :options="contractBarData"/>
            </div>
          </div>
        </common-panel>
      </div>
      <div style="min-width: 20px;"></div>
      <div style="flex: auto;">
        <common-panel>
          <v-chart :options="workLineData"/>
        </common-panel>
      </div>
    </div>
    <div style="min-height: 20px;"></div>
    <div class="overview-main">
      <div class="overview-main-left" style="width: 45%;">
        <common-panel>
          <el-row class="progress-title">
            <el-col :span="8">
              &nbsp;
            </el-col>
            <el-col :span="8" class="progress-title-text">
              <span>工程进度</span>
            </el-col>
            <el-col :span="8" class="progress-title-sub">
              {{`截止今天（${this.$moment(progress.now).format('M月D日')}）`}}
            </el-col>
          </el-row>
          <div class="progress-item">
            <div class="progress-item-label">
              {{((progress.projectSchedule || {}).projectName || '').substr(0, 10)}}
            </div>
            <div style="flex: 1;">
              <el-tooltip
                placement="bottom"
                class="item"
                effect="dark">
                <div slot="content">
                  {{(progress.projectSchedule || {}).projectName}}<br/>
                  {{formatDateChn((progress.projectSchedule || {}).planStartupTime)}}
                   - {{formatDateChn((progress.projectSchedule || {}).planCompletedTime)}}<br/>
                  最新验收: {{(progress.projectSchedule || {}).applyName}}<br/>
                  进度状态: {{formatProgressText(progress.projectSchedule || {})}}
                </div>
                <el-progress
                  :class="`progress-gradient-${(progress.projectSchedule || {}).schedule >= 100 ?
                    'delay' : (progress.projectSchedule || {}).schedule < 85 ?
                    'normal' : 'expiring'}`"
                  :percentage="(progress.projectSchedule || {}).schedule || 0"
                  :text-inside="true"
                  :stroke-width="20"
                  :format="formatProgress(progress.projectSchedule || {})">
                </el-progress>
              </el-tooltip>
            </div>
          </div>
          <div class="progress-scrollbar">
            <div
              v-for="item in progressBarData"
              :key = "item.id"
              class="progress-item">
              <div class="progress-item-label">{{(item.projectName || '').substr(0, 10)}}</div>
              <div style="flex: 1;">
                <el-tooltip
                  placement="bottom"
                  class="item"
                  effect="dark">
                  <div slot="content">
                    {{item.projectName}}<br/>
                    {{formatDateChn(item.planStartupTime)}}
                     - {{formatDateChn(item.planCompletedTime)}}<br/>
                    最新验收: {{item.applyName}}<br/>
                    进度状态: {{formatProgressText(item)}}
                  </div>
                  <el-progress
                    :class="`progress-gradient-${
                      item.projectStatus === '60' ? 'finish' :
                      (item.schedule >= 100 ? 'delay' :
                      (item.schedule < 85 ? 'normal' : 'expiring'))}`"
                    :percentage="item.schedule || 0"
                    :text-inside="true"
                    :stroke-width="20"
                    :format="formatProgress(item)">
                  </el-progress>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="progress-icon">
            <span class="progress-icon-normal"></span>
            <span class="progress-icon-text">工期正常</span>
            <span class="progress-icon-finish"></span>
            <span class="progress-icon-text">已完工</span>
            <span class="progress-icon-expiring"></span>
            <span class="progress-icon-text">工期紧张</span>
            <span class="progress-icon-delay"></span>
            <span class="progress-icon-text">工期已超</span>
          </div>
        </common-panel>
      </div>
      <div style="min-width: 20px;"></div>
      <div class="overview-main-right">
        <div style="flex: 1;">
          <common-panel>
            <v-chart :options="attendanceBarData" />
          </common-panel>
        </div>
        <div style="min-height: 20px;"></div>
        <div style="height: 216px;">
          <common-panel>
            <div class="news-area">
              <div class="news-title">最新动态</div>
              <div class="news-container">
                <transition-group name="news-line" mode="out-in"  tag="div">
                  <div class="news-line"
                    :key="`${item.num }`"
                    v-for="item in newsData">
                    <div class="news-type">
                      <span :class="`news-type-${item.type}`">
                        {{ item.type === 'acceptance' ? '验收' :
                        (item.type === 'reward' ? '奖励' : '处罚') }}
                      </span>
                    </div>
                    <div class="news-text">{{item.text}}</div>
                    <div class="news-time">{{item.time}}</div>
                  </div>
                </transition-group>
              </div>
            </div>
          </common-panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/graphic';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';

import { formatLbgj, formatChn } from '@/util/dateUtils';

import CommonPanel from '@/components/CommonPanel.vue';
import NavMenu from '@/components/NavMenu.vue';
import {
  PROJECT_OVERVIEW_CONTRACT, PROJECT_OVERVIEW_WORKER, PROJECT_OVERVIEW_PROGRESS,
  PROJECT_OVERVIEW_ATTENDANCE, PROJECT_OVERVIEW_NEWS,
} from '@/api/bigdata';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    CommonPanel,
    NavMenu,
    'v-chart': ECharts,
  },
  data() {
    return {
      infoAndContract: {},
      workerList: [],
      attendanceList: [],
      progress: {},
      news: {},
      newsData: [],
    };
  },
  created() {
    this.getData(this.id);
    setInterval(() => {
      const len = this.newsData.length;
      if (len > 0) {
        const item = this.newsData.shift();
        this.newsData.push(Object.assign(item, {
          num: item.num + len,
        }));
      }
    }, 3000);
  },
  computed: {
    contractBarData() {
      return {
        title: {
          x: 'center',
          top: 3,
          text: '劳动合同签订率',
          textStyle: {
            color: '#D8D8D8',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
          },
          formatter: (params) => {
            let text = '0%';
            if (params[0].value !== 0) {
              text = `${Number(params[1].value * 100 / params[0].value).toFixed(0)}%`;
            }
            return `${params[0].name}<br/>
            ${params[0].seriesName} : ${params[0].value}<br/>
            ${params[1].seriesName} : ${params[1].value}<br/>
            签订率 : ${text}`;
          },
        },
        grid: {
          left: 40,
          right: 20,
          bottom: 20,
        },
        graphic: [
          {
            type: 'group',
            right: 5,
            top: 3,
            z: 100,
            children: [
              {
                type: 'circle',
                left: 0,
                top: 0,
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#0DD9D2',
                },
              },
              {
                type: 'text',
                left: 15,
                top: 0,
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '已签',
                },
              },
              {
                type: 'circle',
                left: 0,
                top: 15,
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#0DD9D2',
                },
              },
              {
                type: 'circle',
                left: 2,
                top: 17,
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 3,
                },
                style: {
                  fill: '#040016',
                },
              },
              {
                type: 'text',
                left: 15,
                top: 15,
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '应签',
                },
              },
            ],
          },
        ],
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
          axisLabel: {
            interval: 0,
            formatter: (value) => {
              const strArr = value.split('').slice(0, 10);
              if (strArr.length > 5) {
                strArr.splice(5, 0, '\n');
              }
              const str = strArr.join('');
              return `{richCss|${str}}`;
            },
            rich: {
              richCss: {
                align: 'center',
              },
            },
          },
          data: ['管理人员', '作业工人'],
        },
        yAxis: {
          type: 'value',
          name: '(人)',
          minInterval: 1,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
        },
        series: [
          {
            name: '应签',
            type: 'bar',
            silent: true,
            barWidth: 20,
            barCategoryGap: 40,
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#D8D8D8',
              },
              formatter: (params) => {
                let text = this.infoAndContract.managerSignNumber;
                if (params.dataIndex === 1) {
                  text = this.infoAndContract.workerSignNumber;
                }
                if (params.value === 0) {
                  return `${params.value}(0%)`;
                }
                return `${params.value}(${Number(text * 100 / params.value).toFixed(0)}%)`;
              },
            },
            itemStyle: {
              color: '#040016',
              barBorderColor: '#0DD9D2',
              barBorderWidth: 3,
              barBorderRadius: 0,
            },
            data: [this.infoAndContract.managerNumber, this.infoAndContract.workerNumber],
          },
          {
            name: '已签',
            type: 'bar',
            barGap: '-100%',
            barWidth: 20,
            barCategoryGap: 40,
            label: {
              show: true,
              position: 'inside',
              textStyle: {
                color: '#D8D8D8',
              },
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#0DD9D2' },
                { offset: 1, color: '#08B6FF' }]),
            },
            data: [this.infoAndContract.managerSignNumber, this.infoAndContract.workerSignNumber],
          },
        ],
      };
    },
    workLineData() {
      return {
        title: {
          x: 'center',
          top: 3,
          text: '作业工人变化情况',
          textStyle: {
            color: '#D8D8D8',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
          },
        },
        dataZoom: [
          {
            type: 'slider',
            show: (this.workerList || []).length > 42,
            xAxisIndex: [0],
            start: 0,
            end: Number(42 * 100 / (this.workerList || []).length).toFixed(0),
            height: 5,
            bottom: 3,
            zoomLock: true,
            showDetail: false,
            backgroundColor: '#424150',
            borderColor: '#424150',
            fillerColor: '#41CCFF',
          },
        ],
        grid: {
          left: 40,
          right: 20,
          bottom: 40,
        },
        graphic: [
          {
            type: 'group',
            right: 10,
            top: 10,
            z: 100,
            children: [
              {
                type: 'circle',
                left: 0,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#FE9205',
                },
              },
              {
                type: 'text',
                left: 15,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '应打卡',
                },
              },
              {
                type: 'circle',
                left: 80,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#0BE21A',
                },
              },
              {
                type: 'text',
                left: 95,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '已打卡',
                },
              },
            ],
          },
        ],
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
          axisLabel: {
            interval: 6,
          },
          data: this.workerList.map(item => this.$moment(item.bizDate).format('YYYY-M-D')),
        },
        yAxis: {
          type: 'value',
          name: '(人)',
          minInterval: 1,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
        },
        visualMap: [{
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          inRange: {
            color: ['#FE9205', '#FF3C00'],
          },
        }, {
          show: false,
          type: 'continuous',
          seriesIndex: 1,
          inRange: {
            color: ['#0BE21A', '#0CFF00'],
          },
        }],
        series: [
          {
            name: '应打卡',
            type: 'line',
            symbol: 'circle',
            symbolSize: 7,
            data: this.workerList.map(item => item.workerNumber),
          },
          {
            name: '已打卡',
            type: 'line',
            symbol: 'circle',
            symbolSize: 7,
            data: this.workerList.map(item => item.clockNumber),
          },
        ],
      };
    },
    attendanceBarData() {
      return {
        title: {
          x: 'center',
          text: '本月每日考勤统计',
          textStyle: {
            color: '#D8D8D8',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
          },
          formatter: (params) => {
            let text = '0%';
            if (params[0].value !== 0) {
              text = `${Number(params[1].value * 100 / params[0].value).toFixed(0)}%`;
            }
            return `${((this.attendanceList || [])[params[0].dataIndex]).bizDate}<br/>
            ${params[0].seriesName} : ${params[0].value}<br/>
            ${params[1].seriesName} : ${params[1].value}<br/>
            出勤率 : ${text}`;
          },
        },
        dataZoom: [
          {
            type: 'slider',
            show: (this.attendanceList || []).length > 9,
            xAxisIndex: [0],
            start: 0,
            end: Number(9 * 100 / (this.attendanceList || []).length).toFixed(0),
            height: 5,
            bottom: 3,
            zoomLock: true,
            showDetail: false,
            backgroundColor: '#424150',
            borderColor: '#424150',
            fillerColor: '#41CCFF',
          },
        ],
        grid: {
          left: 40,
          right: 35,
          bottom: 40,
        },
        graphic: [
          {
            type: 'group',
            right: 10,
            top: 10,
            z: 100,
            children: [
              {
                type: 'circle',
                left: 0,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#F83A21',
                },
              },
              {
                type: 'text',
                left: 15,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '已打卡',
                },
              },
              {
                type: 'circle',
                left: 80,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#F83A21',
                },
              },
              {
                type: 'circle',
                left: 82,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 3,
                },
                style: {
                  fill: '#040016',
                },
              },
              {
                type: 'text',
                left: 95,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '应打卡',
                },
              },
            ],
          },
        ],
        xAxis: {
          type: 'category',
          // name: '(日)',
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
          axisLabel: {
            interval: 0,
          },
          data: (this.attendanceList || []).map(item => this.$moment(item.bizDate).format('M-D')),
        },
        yAxis: {
          type: 'value',
          name: '(人)',
          minInterval: 1,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
        },
        series: [
          {
            name: '应打卡',
            type: 'bar',
            silent: true,
            barWidth: 10,
            barCategoryGap: 10,
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#D8D8D8',
              },
            },
            itemStyle: {
              color: '#040016',
              barBorderColor: '#F83A21',
              barBorderWidth: 3,
              barBorderRadius: 0,
              // opacity: 0.1,
            },
            data: (this.attendanceList || []).map(item => item.workerNumber),
          },
          {
            name: '已打卡',
            type: 'bar',
            barGap: '-100%',
            barWidth: 10,
            barCategoryGap: 10,
            label: {
              show: true,
              position: 'inside',
              textStyle: {
                color: '#D8D8D8',
              },
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F83A21' },
                { offset: 1, color: '#FE7723' }]),
            },
            data: (this.attendanceList || []).map(item => item.clockNumber),
          },
        ],
      };
    },
    progressBarData() {
      return (this.progress.subProjectSchedules || []);
    },
  },
  watch: {
    id: 'getData',
  },
  methods: {
    formatProgressText(project) {
      const { projectStatus, schedule } = project;
      if (projectStatus === '60') {
        return '已完工';
      }
      if (schedule < 85) {
        return '工期正常';
      }
      if (schedule >= 100) {
        return '工期已超';
      }
      return '工期紧张';
    },
    formatProgress(item) {
      return () => item.applyName || '';
    },
    formatDateChn(date) {
      return formatChn(date);
    },
    getData(projectId) {
      const company = this.$store.getters.getCompany;
      const params = { companyId: company.companyId, projectId };
      this.$axios.jsonGet(PROJECT_OVERVIEW_CONTRACT, params).then((result) => {
        if (result.code === 0) {
          this.infoAndContract = result.data || {};
        }
      });
      this.$axios.jsonGet(PROJECT_OVERVIEW_WORKER, params).then((result) => {
        if (result.code === 0) {
          this.workerList = result.data || [];
        }
      });
      this.$axios.jsonGet(PROJECT_OVERVIEW_ATTENDANCE, params).then((result) => {
        if (result.code === 0) {
          this.attendanceList = result.data || [];
        }
      });
      this.$axios.jsonGet(PROJECT_OVERVIEW_PROGRESS, params).then((result) => {
        if (result.code === 0) {
          this.progress = result.data || {};
        }
      });
      this.$axios.jsonGet(PROJECT_OVERVIEW_NEWS, params).then((result) => {
        if (result.code === 0) {
          this.news = result.data || {};
          this.newsData = [];
          (this.news.acceptanceVos || []).map(item => this.newsData.push({
            num: this.newsData.length,
            type: 'acceptance',
            time: formatLbgj(this.news.now, item.time),
            text: `${item.currentProject ? '' : `${item.projectName || ''}的`}${
              item.nodeName || ''}已验收通过，累计已完成${item.count || '0'}次验收`,
          }));
          (this.news.rewardPunishs || []).map(item => this.newsData.push({
            num: this.newsData.length,
            type: item.type,
            time: formatLbgj(this.news.now, item.time),
            text: `${item.currentProject ? '收到新的' : `对${
              item.projectName || ''}签发新的`}${
              item.type === 'reward' ? '奖励' : '处罚'}，金额${
              Number(item.amount || '0').toFixed(2)}元，累计${
              item.currentProject ? '被' : ''}${
              item.type === 'reward' ? '奖励' : '处罚'}${
              item.count || '0'}次、${Number(item.totalAmount || '0').toFixed(2)}元`,
          }));
          this.newsData.sort((o1, o2) => o1.time - o2.time);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/theme/app.scss';

  @mixin overview-flex {
    display: flex;
  }

  .overview {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: $font-color;
    &-top {
      height: 30%;
      display: flex;
      justify-content: center;
    }
    &-main {
      display: flex;
      flex: 1;
      &-left {
        width: 45%;
      }
      &-right {
        flex: 1;
        @include overview-flex;
        flex-direction: column;
      }
    }
  }

  .info-title {
    padding-bottom: 1rem;
  }

  .base-info {
    display: flex;
    height: 100%;
    .base-left {
      flex: 1;
      height: 100%;
      padding: 0rem 1rem 0.5rem 1rem;
      > .line {
        height: 1.5rem;
      }
    }
    .title {
      font-size: 1.2rem;
    }
    .hight {
      color: $font-color-hight;
    }
    .normal-text {
      font-size: 0.9rem;
      line-height: 1.5rem;
    }
    .base-right {
      width: 40%;
      height: 100%;
      padding: 0rem 0rem 0.5rem 0.5rem;
      border-left: 1px solid #323142;
    }
  }

  .progress {
    &-title {
      padding-bottom: 0.5rem;
    }
    &-title-text {
      text-align: center;
      font-size: 1.2rem;
      font-weight: bold;
    }
    &-title-sub {
      text-align: right;
      font-size: 0.8rem;
    }
    &-scrollbar {
      padding-left: 40px;
      max-height: 300px;
      height: 300px;
      overflow-y: auto;
      /*三角箭头的颜色*/
      scrollbar-arrow-color: #D8D8D8;
      /*滚动条滑块按钮的颜色*/
      scrollbar-face-color: #41CCFF;
      /*滚动条整体颜色*/
      scrollbar-highlight-color: #D8D8D8;
      /*滚动条阴影*/
      scrollbar-shadow-color: #D8D8D8;
      /*滚动条轨道颜色*/
      scrollbar-track-color: #D8D8D8;
      /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
      scrollbar-3dlight-color:#D8D8D8;
      /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
      scrollbar-darkshadow-color: #D8D8D8;
      /*滚动条基准颜色*/
      scrollbar-base-color: #D8D8D8;
      /*滚动条整体部分,必须要设置*/
      &::-webkit-scrollbar {
        border-radius: 3px;
        width: 3px;
        height: 3px;
        background-color: #D8D8D8;
      }
      /*滚动条的轨道*/
      &::-webkit-scrollbar-track {
        border-radius: 3px;
        background-color: #D8D8D8;
      }
      /*滚动条的滑块按钮*/
      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: #41CCFF;
        box-shadow: inset 0 0 3px #41CCFF;
      }
      /*滚动条的上下两端的按钮*/
      &::-webkit-scrollbar-button {
        height: 0;
        background-color: #D8D8D8;
      }
    }
    &-item {
      display: flex;
      align-items: center;
      padding: 0.25rem 2rem 0.25rem 0rem;
      &-label {
        font-size: 0.8rem;
        max-width: 4rem;
        width: 4rem;
        height: 2.5rem;
        overflow: hidden;
      }
    }
    &-icon {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      font-size: 0.8rem;
      &-text {
        padding-left: 0.5rem;
        padding-right: 2rem;
      }
      &-normal {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 0.8rem;
        background-color: #08B6FF;
      }
      &-expiring {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 0.8rem;
        background-color: #FE7723;
      }
      &-delay {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 0.8rem;
        background-color: #E91D04;
      }
      &-finish {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 0.8rem;
        background-color: #18AD1F;
      }
    }
  }

  .progress-item /deep/ .el-progress-bar__outer {
    background: #363545;
  }

  .progress-item /deep/ .el-progress-bar__innerText {
    text-align: left;
    padding-left: 1rem;
  }

  .progress-gradient-normal /deep/ .el-progress-bar__inner {
    background: linear-gradient(to right, #0DD9D2, #08B6FF);
  }
  .progress-gradient-expiring /deep/ .el-progress-bar__inner {
    background: linear-gradient(to right, #FEBE1A, #FE7723);
  }
  .progress-gradient-delay /deep/ .el-progress-bar__inner {
    background: linear-gradient(to right, #FE7723, #E91D04);
  }
  .progress-gradient-finish /deep/ .el-progress-bar__inner {
    background: linear-gradient(to right, #7ED482, #18AD1F);
  }

  .news {
    &-area {
      padding: 0rem 1rem 0.5rem 1rem;
      max-height: 100%;
      overflow: hidden;
    }
    &-title {
      font-size: 1.2rem;
      text-align: center;
      padding-bottom: 0.2rem;
    }
    &-container {
      max-height: 100%;
      overflow: hidden;
      position: relative;
    }
    &-line {
      display: flex;
      height: 40px;
      width: 98%;
      line-height: 40px;
      transition: all 1s;
      overflow: hidden;
      &-enter {
        display: flex;
        opacity: 0;
        transform: translateY(40px);
      }
      &-leave-to {
        display: flex;
        opacity: 0;
        transform: translateY(-40px);
      }
      &-leave-active {
        display: flex;
        position: absolute;
      }
    }
    &-type {
      &-base {
        border: 1px solid $font-color;
        border-radius: 3px;
        padding: 0.2rem 0.5rem;
        color: $font-color;
        font-size: 0.8rem;
      }
      &-acceptance {
        @extend .news-type-base;
        border-color: #0DD9D2;
        color: #0DD9D2;
        width: 3rem;
      }
      &-reward {
        @extend .news-type-base;
        border-color: #FE5959;
        color: #FE5959;
      }
      &-punish {
        @extend .news-type-base;
        border-color: #FEBE1A;
        color: #FEBE1A;
      }
    }
    &-text {
      float: left;
      color: $font-color;
      flex: 1;
      padding-left: 0.6rem;
      overflow: hidden;
    }
    &-time {
      width: 90px;
      text-align: right;
      color: $font-color;
    }
  }

</style>
